import { z } from "zod";
// A location the kiosk can be set to serve — the ICIS csg_location id and its
// display name. The set of these is sourced from ICIS (see the locations
// endpoint) and populates the location-select dropdown.
export const LocationEntitySchema = z.object({
    id: z.string(),
    name: z.string(),
});
export const LocationsResponseSchema = z.object({
    locations: LocationEntitySchema.array(),
});
